import React from 'react';
import { useParams } from 'react-router-dom';
import EEForGovernmentOfficialsData from '../../../data/EEForGovermentOfficialsData';
import EEForGovenrmentOfficialsTemplate from './EEForGovenrmentOfficialsTemplate';
const ExecutiveGovernmentPage = () => {
  const { id } = useParams();
  const pageData = EEForGovernmentOfficialsData.find(item => item.id === id);
  if (!pageData) {
    return <div>The Route "executive-government/{id}" does not exist. </div>;
  }
  return <EEForGovenrmentOfficialsTemplate data={pageData} />;
};

export default ExecutiveGovernmentPage;
